import { Link } from "react-router-dom";
import { ArrowRight, Lock, Calculator, Target, Table as FileSpreadsheet } from "@phosphor-icons/react";
import { homeSection } from '../lib/marketingHome';

const INK = "#2A1E5C";
const INK2 = "#5D5A6B";
const GOLD = "#F5CB5C";
const PAPER = "#FDFBF7";

const PERKS = [
  [Target, "Your one true weekly number", "Six quick questions turn expenses, taxes, savings, debt and PTO into a single weekly target."],
  [FileSpreadsheet, "It plugs straight into your sheet", "Your numbers land in your Payday Relay Google Sheet automatically. Nothing to retype."],
  [Calculator, "Re-run it any time", "Recalibrate at every quarterly tax day as your year changes shape."],
];

/** The Relay Calculator is Step 1 inside Payday Relay, a Sprint or Season Pass unlocks it. */
export const CalculatorGate = ({ checking = false, error = false }) => {
  if (checking) {
    return (
      <main className="flex-1 flex items-center justify-center px-6 py-24" data-testid="calculator-gate-checking">
        <p className="text-sm animate-pulse" style={{ color: INK2 }}>Checking your access…</p>
      </main>
    );
  }

  if (error) {
    return (
      <main className="flex-1 flex items-center justify-center px-6 py-24" data-testid="calculator-gate-error">
        <div className="text-center max-w-sm">
          <p className="text-base font-bold mb-2" style={{ color: INK }}>We couldn't check your access just now</p>
          <p className="text-sm mb-6" style={{ color: INK2 }}>
            That's on us, not you, the connection hiccuped. Give it another go.
          </p>
          <button
            onClick={() => window.location.reload()}
            className="px-6 py-3 rounded-full font-bold text-sm transition-transform hover:scale-105"
            style={{ background: GOLD, color: INK }}
            data-testid="calculator-gate-retry"
          >
            Try again
          </button>
        </div>
      </main>
    );
  }

  return (
    <main className="flex-1 px-5 sm:px-8 py-14 sm:py-20" style={{ background: PAPER }} data-testid="calculator-gate">
      <div className="max-w-2xl mx-auto text-center">
        <span
          className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full text-[11px] font-bold uppercase tracking-[0.16em] mb-6"
          style={{ background: "rgba(42,30,92,0.06)", color: INK }}
        >
          <Lock className="w-3.5 h-3.5" style={{ color: "#C9861B" }} /> Step 1 inside Payday Relay
        </span>
        <h1 className="text-4xl sm:text-5xl leading-[1.1] mb-5" style={{ fontFamily: "'Fraunces', Georgia, serif", color: INK }}>
          The Relay Calculator runs inside your race
        </h1>
        <p className="text-base sm:text-lg leading-relaxed mb-10" style={{ color: INK2 }}>
          It isn't a standalone tool, it's the first leg of the Payday Relay system, and it comes with
          every Free Sprint and Season Pass. Start your sprint and it's waiting on your first screen.
        </p>

        <div className="flex flex-col sm:flex-row gap-3 justify-center mb-4">
          <Link
            to="/start/free-sprint"
            className="inline-flex items-center justify-center gap-2 px-8 py-4 rounded-full font-bold text-base sm:text-lg transition-transform hover:scale-[1.03] shadow-lg"
            style={{ background: GOLD, color: INK }}
            data-testid="calculator-gate-free-sprint"
          >
            Start my Free Sprint <ArrowRight className="w-4 h-4" />
          </Link>
          <Link
            to={homeSection('season-pass')}
            className="inline-flex items-center justify-center px-8 py-4 rounded-full font-semibold text-base sm:text-lg border-2 transition-transform hover:scale-[1.03]"
            style={{ borderColor: INK, color: INK, background: "transparent" }}
            data-testid="calculator-gate-season-pass"
          >
            Get Payday Relay
          </Link>
        </div>
        <p className="text-xs mb-12" style={{ color: "#8B7E6A" }}>
          $0 today on the sprint · cancel anytime before day 28 ·{" "}
          <Link to="/login" className="underline" style={{ color: INK }} data-testid="calculator-gate-signin">
            already a member? Sign in
          </Link>
        </p>

        <div className="grid gap-3 text-left">
          {PERKS.map(([Icon, title, body]) => (
            <div
              key={title}
              className="rounded-2xl px-5 py-4 flex items-start gap-4"
              style={{ background: "#FFFFFF", border: "1px solid rgba(42,30,92,0.1)" }}
            >
              <span className="w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0" style={{ background: "rgba(245,203,92,0.25)" }}>
                <Icon className="w-5 h-5" style={{ color: INK }} />
              </span>
              <span>
                <p className="text-sm font-bold mb-0.5" style={{ color: INK }}>{title}</p>
                <p className="text-sm leading-relaxed" style={{ color: INK2 }}>{body}</p>
              </span>
            </div>
          ))}
        </div>
      </div>
    </main>
  );
};

export default CalculatorGate;
